import * as joint from '../joint-plus/joint-plus.min.js'
import '../joint-plus/joint-plus.min.css'
import dagre from 'dagre'
import graphlib from 'graphlib'
window.dagre = dagre
window.graphlib = graphlib
window.joint = joint
import './diagram.jsx'
import './stencil.jsx'